// Stamp icon picker — wizard step 3.
//
// Built-in icons only. Picking one writes `builtin:<id>:filled` /
// `builtin:<id>:empty` to pass_design. Custom uploads were removed: the
// bundled set covers the V1 owner segment (cafés / milk tea / salons) and
// keeps the wallet hero compositing pipeline simpler.

import type { BuiltinStampIcon, PassDesign } from '@naya/shared'

import {
  BUILTIN_STAMP_ICONS,
  BUILTIN_STAMP_ICON_LABELS,
  StampIcon,
  parseBuiltinRef,
} from '../../../assets/stamp-icons/index.js'

export function StampIconPicker({
  passDesign,
  onChange,
}: {
  passDesign: PassDesign
  onChange: (next: Pick<PassDesign, 'stamp_filled_url' | 'stamp_empty_url'>) => void
}) {
  const filledRef = passDesign.stamp_filled_url
  const builtin = parseBuiltinRef(filledRef)

  function pickBuiltin(id: BuiltinStampIcon) {
    onChange({
      stamp_filled_url: `builtin:${id}:filled`,
      stamp_empty_url: `builtin:${id}:empty`,
    })
  }

  return (
    <div className="program-icon-picker">
      <div className="program-icon-grid">
        {BUILTIN_STAMP_ICONS.map((id) => {
          const selected = builtin?.id === id
          return (
            <button
              key={id}
              type="button"
              className={`program-icon-choice${selected ? ' is-selected' : ''}`}
              onClick={() => pickBuiltin(id)}
              aria-pressed={selected}
              aria-label={BUILTIN_STAMP_ICON_LABELS[id]}
            >
              <span className="program-icon-choice-glyph">
                <StampIcon refValue={`builtin:${id}:filled`} state="filled" />
              </span>
              <span className="program-icon-choice-label">
                {BUILTIN_STAMP_ICON_LABELS[id]}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
